export const REDIRECT_DELAY = 1000;

export const URL_PREPARE = '/deposit/prepare';
export const URL_REDIRECT = '/deposit/redirect';
export const URL_PROCESS_RESULT = '/deposit/result';
